export default defineAppConfig({
  ui: {
    colors: {
      primary: 'indigo',
      secondary: 'amber',
      neutral: 'slate'
    },
    input: {
      slots: {
        root: 'w-full'
      }
    },
    textarea: {
      slots: {
        root: 'w-full'
      }
    },
    select: {
      slots: {
        root: 'w-full'
      }
    }
  }
})
